import base from './baseApi';
import { queryFilter } from 'utils/proptypes';

const { urls, methods, execute } = base();
const getRoles = (queryFilter: queryFilter) => {
  const { page, limit } = queryFilter;

  const method = methods.GET;
  const url = `${urls.role.Roles}?page=${page}&limit=${limit}&withDeleted=false`;
  const response = execute(method, url, { authorization: true });

  return response;
};

export { getRoles };
